import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "mt-8 space-y-5" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row gap-3" }
const _hoisted_4 = { class: "flex rounded-md overflow-hidden border border-gray-200 bg-white" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "relative flex-1" }
const _hoisted_7 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_8 = {
  key: 1,
  class: "text-center py-16 text-gray-400"
}
const _hoisted_9 = {
  key: 2,
  class: "space-y-3"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-gray-100" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center text-gray-300"
}
const _hoisted_14 = { class: "flex-1 min-w-0" }
const _hoisted_15 = { class: "font-semibold text-gray-800 truncate" }
const _hoisted_16 = { class: "flex items-center gap-2 mt-1 flex-wrap" }
const _hoisted_17 = { class: "text-xs text-gray-400" }
const _hoisted_18 = { class: "flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity" }
const _hoisted_19 = { class: "relative tooltip-wrapper" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_22 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_23 = { class: "tooltip-text absolute bottom-full left-1/2 -translate-x-1/2 mb-1 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap pointer-events-none z-10" }
const _hoisted_24 = { class: "relative tooltip-wrapper" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "relative tooltip-wrapper" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 3,
  class: "flex items-center justify-between"
}
const _hoisted_29 = { class: "text-sm text-gray-500" }
const _hoisted_30 = { class: "flex gap-1" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]

import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Swal from 'sweetalert2';
import { GET_ACTIVITIES, DELETE_ACTIVITY, POST_ACTIVITY, PUBLISH_ACTIVITY, GET_ACTIVITY_COUNTS, PUT_ACTIVITY } from '@/store/activity.module';
import Breadcrumb from '@/components/AppBreadcrumb.vue';
import AppSelect from '@/components/input/AppSelect.vue';

const title = 'Kegiatan';

export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityView',
  setup(__props) {

const store = useStore();
const router = useRouter();

const isLoading = ref(true);
const search = ref('');
const activeFilter = ref('all');
const sort = ref('newest');
const page = ref(1);
const limit = ref(10);

const filters = computed(() => [
  { label: 'Semua', value: 'all', count: totalAll.value },
  { label: 'Draft', value: 'draft', count: totalDraft.value },
  { label: 'Published', value: 'published', count: totalPublished.value },
]);

const activitiesData = computed(() => store.getters.activities);
const activities = computed(() => activitiesData.value?.data || []);
const totalEntries = computed(() => activitiesData.value?.pagination?.totalEntries || 0);
const totalPages = computed(() => activitiesData.value?.pagination?.totalPages || 0);
const start = computed(() => activitiesData.value?.pagination?.start || 0);
const end = computed(() => activitiesData.value?.pagination?.end || 0);

const totalDraft = ref(0);
const totalPublished = ref(0);
const totalAll = ref(0);

const sortOptions = [
  { value: 'newest', label: 'Terbaru' },
  { value: 'oldest', label: 'Terlama' },
  { value: 'az', label: 'A-Z' },
  { value: 'za', label: 'Z-A' },
]

const retractActivity = async (activity: any) => {
  const result = await Swal.fire({
    title: 'Tarik ke draft?',
    text: 'Kegiatan tidak akan terlihat publik.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d97706',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Ya, tarik ke draft',
    cancelButtonText: 'Batal'
  });
  if (result.isConfirmed) {
    await store.dispatch(PUT_ACTIVITY, { id: activity.id, data: { status: 'draft' } });
    await fetchData();
  }
};

const fetchCounts = async () => {
  const counts = await store.dispatch(GET_ACTIVITY_COUNTS);
  totalDraft.value = counts.draft;
  totalPublished.value = counts.published;
  totalAll.value = counts.total;
};

const fetchData = async () => {
  isLoading.value = true;
  await Promise.all([
    store.dispatch(GET_ACTIVITIES, {
      search: search.value,
      page: page.value,
      limit: limit.value,
      status: activeFilter.value === 'all' ? undefined : activeFilter.value,
      sort: sort.value,
    }),
    fetchCounts()
  ]);
  isLoading.value = false;
};

const getSortOrder = () => {
  switch (sort.value) {
    case 'oldest': return [['createdAt', 'ASC']];
    case 'az': return [['title', 'ASC']];
    case 'za': return [['title', 'DESC']];
    default: return [['createdAt', 'DESC']];
  }
};

let searchTimer: any = null;
const debouncedFetch = () => {
  clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    page.value = 1;
    fetchData();
  }, 400);
};

const formatDate = (dateStr: string) => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('id-ID', {
    day: 'numeric', month: 'short', year: 'numeric'
  });
};

const createNew = () => {
  router.push({ name: 'KegiatanEditor', params: { id: 'new' } });
};

const goToEditor = (id: number) => {
  router.push({ name: 'KegiatanEditor', params: { id } });
};

const previewActivity = (activity: any) => {
  const route = router.resolve({ name: 'KegiatanPreview', params: { id: activity.id } });
  window.open(route.href, '_blank');
};

const publishActivity = async (activity: any) => {
  const result = await Swal.fire({
    title: 'Publish kegiatan ini?',
    text: 'Kegiatan akan dipublikasikan dan dapat dilihat publik.',
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#2563eb',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Ya, publish!',
    cancelButtonText: 'Batal'
  });
  if (result.isConfirmed) {
    await store.dispatch(PUBLISH_ACTIVITY, activity.id);
    await fetchData();
    Swal.fire({ title: 'Published!', icon: 'success', confirmButtonColor: '#2563eb' });
  }
};

const deleteActivity = async (activity: any) => {
  const result = await Swal.fire({
    title: 'Hapus kegiatan ini?',
    text: 'Data yang dihapus tidak dapat dikembalikan.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc2626',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Ya, hapus!',
    cancelButtonText: 'Batal'
  });
  if (result.isConfirmed) {
    await store.dispatch(DELETE_ACTIVITY, { id: activity.id });
    await fetchData();
  }
};

onMounted(fetchData);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumb, { breadcrumb: title }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", { class: "relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6" }, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
        _createElementVNode("div", { class: "relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-2xl font-bold md:text-4xl" }, _toDisplayString(title)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mt-2 max-w-2xl text-sm leading-relaxed text-blue-100" }, " Kelola dan tinjau semua post kegiatan yang tampil pada halaman publik. ", -1))
          ]),
          _createElementVNode("button", {
            onClick: createNew,
            class: "inline-flex w-full items-center justify-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[#003793] shadow-lg transition-all hover:-translate-y-px hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-white/70 sm:w-auto"
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 4v16m8-8H4"
              })
            ], -1),
            _createTextVNode(" Tulis Kegiatan ", -1)
          ]))])
        ])
      ]),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filters.value, (f) => {
            return (_openBlock(), _createElementBlock("button", {
              key: f.value,
              onClick: ($event: any) => {activeFilter.value = f.value; fetchData()},
              class: _normalizeClass([activeFilter.value === f.value ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-50', "px-4 py-2 text-sm font-medium transition-colors"])
            }, _toDisplayString(f.label) + " (" + _toDisplayString(f.value === 'all' ? totalAll.value : f.value === 'draft' ? totalDraft.value : totalPublished.value) + ") ", 11, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[8] || (_cache[8] = _createElementVNode("svg", {
            class: "absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            })
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
            onInput: debouncedFetch,
            placeholder: "Cari berdasarkan judul, tag kategori, atau konten...",
            class: "w-full pl-10 pr-4 py-2 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
          }, null, 544), [
            [_vModelText, search.value]
          ])
        ]),
        _createVNode(AppSelect, {
          modelValue: sort.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sort).value = $event)),
          options: sortOptions,
          class: "w-full sm:w-40",
          onChange: fetchData
        }, null, 8, ["modelValue"])
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
              return _createElementVNode("div", {
                key: i,
                class: "h-24 bg-gray-100 rounded-xl animate-pulse"
              })
            }), 64))
          ]))
        : (activities.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("svg", {
                class: "w-12 h-12 mx-auto mb-3 opacity-40",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.5",
                  d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                })
              ], -1),
              _createElementVNode("p", { class: "text-sm" }, "Belum ada kegiatan", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activities.value, (activity) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: activity.id,
                  onClick: ($event: any) => (goToEditor(activity.id)),
                  class: "group relative flex items-center gap-4 bg-white rounded-xl border border-gray-200 p-4 cursor-pointer hover:border-blue-300 hover:shadow-sm transition-all"
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    (activity.image)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: activity.image,
                          alt: activity.title,
                          class: "w-full h-full object-cover"
                        }, null, 8, _hoisted_12))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[10] || (_cache[10] = [
                          _createElementVNode("svg", {
                            class: "w-6 h-6",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1.5",
                              d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                            })
                          ], -1)
                        ]))]))
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h3", _hoisted_15, _toDisplayString(activity.title || 'Tanpa Judul'), 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", {
                        class: _normalizeClass([activity.status === 'published' ? 'text-green-600' : 'text-yellow-600', "text-xs font-medium"])
                      }, _toDisplayString(activity.status === 'published' ? 'Published' : 'Draft'), 3),
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-gray-300 text-xs" }, "•", -1)),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(activity.status === 'published' ? 'Dipublikasikan' : 'Diperbarui') + " " + _toDisplayString(formatDate(activity.status === 'published' ? activity.createdAt : activity.updatedAt)), 1),
                      (activity.tags?.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-gray-300 text-xs" }, "•", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.tags, (tag) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: tag.id,
                                class: "px-2 py-0.5 text-xs font-medium rounded-full bg-blue-50 text-blue-600"
                              }, _toDisplayString(tag.name), 1))
                            }), 128))
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("button", {
                        onClick: _withModifiers(($event: any) => (activity.status === 'draft' ? publishActivity(activity) : retractActivity(activity)), ["stop"]),
                        class: _normalizeClass([activity.status === 'draft' ? 'text-blue-600 hover:bg-blue-50' : 'text-yellow-600 hover:bg-yellow-50', "p-2 rounded-lg transition-colors"])
                      }, [
                        (activity.status === 'draft')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_21, [...(_cache[13] || (_cache[13] = [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                              }, null, -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_22, [...(_cache[14] || (_cache[14] = [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                              }, null, -1)
                            ]))]))
                      ], 10, _hoisted_20),
                      _createElementVNode("div", _hoisted_23, _toDisplayString(activity.status === 'draft' ? 'Publish' : 'Tarik ke Draft'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("button", {
                        onClick: _withModifiers(($event: any) => (previewActivity(activity)), ["stop"]),
                        class: "p-2 text-gray-500 hover:bg-gray-100 rounded-lg transition-colors"
                      }, [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("svg", {
                          class: "w-4 h-4",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          }),
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                          })
                        ], -1)
                      ]))], 8, _hoisted_25),
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "tooltip-text absolute bottom-full left-1/2 -translate-x-1/2 mb-1 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap pointer-events-none z-10" }, " Preview ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("button", {
                        onClick: _withModifiers(($event: any) => (deleteActivity(activity)), ["stop"]),
                        class: "p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("svg", {
                          class: "w-4 h-4",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          })
                        ], -1)
                      ]))], 8, _hoisted_27),
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "tooltip-text absolute bottom-full left-1/2 -translate-x-1/2 mb-1 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap pointer-events-none z-10" }, " Hapus ", -1))
                    ])
                  ])
                ], 8, _hoisted_10))
              }), 128))
            ])),
      (totalPages.value > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("span", _hoisted_29, " Menampilkan " + _toDisplayString(start.value) + "–" + _toDisplayString(end.value) + " dari " + _toDisplayString(totalEntries.value) + " kegiatan ", 1),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => {page.value--; fetchData()}),
                disabled: page.value <= 1,
                class: "px-3 py-1.5 text-sm border border-gray-200 rounded-md disabled:opacity-40 hover:bg-gray-50 transition-colors"
              }, " Prev ", 8, _hoisted_31),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => {page.value++; fetchData()}),
                disabled: page.value >= totalPages.value,
                class: "px-3 py-1.5 text-sm border border-gray-200 rounded-md disabled:opacity-40 hover:bg-gray-50 transition-colors"
              }, " Next ", 8, _hoisted_32)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})